export default __webpack_public_path__ + "static/media/airQualityAtom.77ab0815.svg";